export default "__VITE_ASSET__BgiWE7pU__"